<div class="modal-main create-user" [formGroup]="formGroup">
  <ng-template #backButtonRef>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </ng-template>

  <ng-container *ngIf="stepper === 1">
    <app-building-activity-detail
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (submitToParent)="submitToParent()"
      (resetFilterData)="resetFilterData()"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-building-activity-detail>
  </ng-container>

  <ng-container *ngIf="stepper === 2">
    <app-user-type
      formGroupName="userType"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-user-type>
  </ng-container>

  <ng-container *ngIf="stepper === 3">
    <app-building-activity-type
      formGroupName="locks"
      formGroupIdName="lockIds"
      [activityTypes]="activityTypes"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-building-activity-type>
  </ng-container>

  <ng-container *ngIf="stepper === 4">
    <app-date-range
      formGroupName="dateRange"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-date-range>
  </ng-container>
</div>
